// extracted by mini-css-extract-plugin
export default {"customLabel":"styles-module__customLabel__src-labstep-web-components-ResourceItemExport-Table-CustomLabel-_ueCph"};